
class MembershipDiscountFormController {
  constructor(discountService, messageService, access) {
    this.discountService = discountService;
    this.messageService = messageService;
    this.access = access;
  }

  onSave() {
    return this.discountService.saveMembershipDiscount(this.details)
      .then((response) => {
          this.messageService.success(`The membership discount has been successfully updated!`);
          this.messageService.push();
          this.messageService.autoClear();
      })
      .catch((error) => {
          this.messageService.failure(`The membership discount has not been successfully updated!`);
          this.messageService.push();
          this.messageService.autoClear();
      });
  }
}

MembershipDiscountFormController.$inject = [ 'discountService', 'messageService', 'access' ];

export default MembershipDiscountFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/controllers/membershipDiscount.controller.js